import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { HttpResponse } from '@angular/common/http';
import { StorageService } from 'src/app/app.storage.service';
import { AuthService } from '../interceptor/auth.service';
declare var $: any;
import Swal from 'sweetalert2'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private router: Router,
    private appService: AppService,
    private storageService: StorageService,
    private authService: AuthService) { }

  username: string = null;
  password: string = null;

  ngOnInit(): void {

  }

  login() {
    if (this.username && this.password) {
      let pass = $.md5(this.password);
      
      this.appService.login(this.username, pass)
        .subscribe((res: HttpResponse<any>) => {
          console.log(res);
          if(res.body.status == 200){
            let userData = res.body.user;
            if(userData){
              // this.authService.setAccessToken(userData.accessToken);
              
              // this.storageService.setDataInLocalStorage("accessToken", userData.accessToken);
              this.storageService.setDataInLocalStorage("userData", userData);
              if(res.body.logo){
                this.storageService.setDataInLocalStorage("logo", res.body.logo);
              }
              this.router.navigate(['home']);
            }
          }else if(res.body.status == 400){
            //alert(res.body.error_description);
           // Swal.fire('Oops...',res.body.error_description,'error');
            this.appService.showInfoPopup("Oops...",res.body.error_description);
          }
          
        }, (error) => {
          console.log(error);
        });

    }else{
      //Swal.fire('Oops...', 'Please enter the username name and password!', 'error');
      this.appService.showInfoPopup("Oops..","Please enter the username name and password!")
    }
    // localStorage.setItem("accessToken", "jkadghlsdfgasfdgi;");
    // this.router.navigate(['home']);
  }

  signup() {
    this.router.navigate(['signup']);
  }

}
